import useTracking from '@clearscore/hooks.use-tracking';

export default () => {
    const track = useTracking();

    return {
        trackLogin: ({ event }) => {
            track({
                name: event,
            });
        },
    };
};
